module.exports = __webpack_public_path__ + "img/ic_room_marketing_left_img2.f98a3013.png";